import { render, staticRenderFns } from "./notification-badge.vue?vue&type=template&id=e2ea5d68&scoped=true"
import script from "./notification-badge.vue?vue&type=script&lang=js"
export * from "./notification-badge.vue?vue&type=script&lang=js"
import style0 from "./notification-badge.vue?vue&type=style&index=0&id=e2ea5d68&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ea5d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2ea5d68')) {
      api.createRecord('e2ea5d68', component.options)
    } else {
      api.reload('e2ea5d68', component.options)
    }
    module.hot.accept("./notification-badge.vue?vue&type=template&id=e2ea5d68&scoped=true", function () {
      api.rerender('e2ea5d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/notification-badge.vue"
export default component.exports